import {AfterContentInit, ChangeDetectorRef, ContentChild, Directive, Injector, Input, ViewChild} from "@angular/core";
import {SelectOptionsComponent} from "../../select/options/select-options.component";
import {SingleSelectControlComponent} from "../../select/single-select-control.component";
import {SelectControlMode} from "../../select/abstract-select-control.component";
import {FUIOptionMetaData, FUISelectAction} from "@fedeltapointofsale/ui";
import {TranslateService} from "@ngx-translate/core";
import {forkJoin, map} from "rxjs";
import {SearchModel} from "@fedeltapointofsale/data-client";

/**
 * Abstract class that implements methods for the select navs
 */
@Directive()
export abstract class AbstractSelectNavComponent <T extends SearchModel<any>> implements AfterContentInit {
    SelectControlMode = SelectControlMode;

    @Input() public label: string;
    @Input() public elementId: string;
    @Input() extendedSearchComponentParams: any;
    @Input() extendedEditComponentParams: any;
    @Input() getOptionMetaData: (option: any) => FUIOptionMetaData = () => undefined;

    @ViewChild(SingleSelectControlComponent) singleSelectControlComponent: SingleSelectControlComponent;
    @ContentChild(SelectOptionsComponent) selectOptionsComponent: SelectOptionsComponent;

    extendedSearchComponent: any;
    extendedEditComponent: any;
    showAddOption: boolean = false;
    actions: FUISelectAction[] = [];

    valueField: string;
    labelField: string;

    translateService: TranslateService;
    changeDetectorRef: ChangeDetectorRef;

    labelSearchField: string;

    data: Array<any> = [];

    constructor(protected model: T,
                injector: Injector,
                valueField: string = "value",
                labelField: string = "label") {
        this.translateService = injector.get(TranslateService, null);
        this.changeDetectorRef = injector.get(ChangeDetectorRef, null);
        this.valueField = valueField;
        this.labelField = labelField;
    }

    ngAfterContentInit(): void {
        if (this.selectOptionsComponent) {
            this.selectOptionsComponent.data$.subscribe(data => {
                this.data = data;
                this.changeDetectorRef.detectChanges();
            });
        }
    }

    buildData(options: { label: string, value?: any }[]): void {
        forkJoin(
            options.map(option =>
                this.translateService.get(option.label).pipe(
                    map(translation => ({
                        [this.labelField]: translation,
                        [this.valueField]: option.value === undefined ? translation : option.value
                    }))
                )
            )
        ).subscribe(results => this.data = results);
    }

    public refreshData() {
        if (this.selectOptionsComponent) {
            this.selectOptionsComponent.refreshData();
        }
        if (this.singleSelectControlComponent) {
            this.singleSelectControlComponent.refreshData();
        }
    }

    abstract onSelect(option: any);

    onAdd() {
    }

    onAction(action: FUISelectAction) {
    }
}
